// View Resource Modal - просмотр изображений и видео

import React from 'react';
import { addTimestampToUrl } from '../../services/api';

interface ViewResourceModalProps {
  isOpen: boolean;
  title: string;
  resourceUrl: string | null;
  onClose: () => void;
}

const ViewResourceModal: React.FC<ViewResourceModalProps> = ({
  isOpen,
  title,
  resourceUrl,
  onClose,
}) => {
  if (!isOpen || !resourceUrl) return null;

  const isVideo = resourceUrl.endsWith('.mp4') || resourceUrl.includes('video') || resourceUrl.includes('lipsync');

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = resourceUrl;
    link.download = resourceUrl.split('/').pop() || 'download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 1200 }} onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: '90vw', maxHeight: '90vh', textAlign: 'center', padding: '20px', zIndex: 1201 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        {isVideo ? (
          <video
            src={addTimestampToUrl(resourceUrl)}
            controls
            style={{ maxWidth: '100%', maxHeight: '70vh', width: 'auto', height: 'auto', borderRadius: '8px' }}
          />
        ) : (
          <img
            src={addTimestampToUrl(resourceUrl)}
            alt={title}
            style={{ maxWidth: '100%', maxHeight: '70vh', width: 'auto', height: 'auto', objectFit: 'contain', borderRadius: '8px' }}
          />
        )}

        <div className="generation-actions" style={{ marginTop: '15px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button onClick={handleDownload} className="btn btn-info">
            Download
          </button>
          <button onClick={onClose} className="btn btn-secondary">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewResourceModal;
